import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// Hook DOMPurify globale: prefisso basename sui link interni dell'HTML da DB
import './utils/dompurifyAppLinks';
// Hook DOMPurify globale: link che escono dall'app aperti in una nuova scheda (iframe)
import './utils/dompurifyExternalLinksNewTab';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
